import React from 'react';
import PillButton from './PillButton';

export interface IGoogleRenderButton {
    onClick : () => void;
    text ?: string;
    className ?: string;
}

/**
 * @param {() => void} onClick Void function callback to fire when button is clicked. Required.
 * @param {string} text Text to be displayed on button. Optional. Defaults to "Sign in with Google"
 * @param {string} className - Additional scss classname(s) to apply to the component. Optional.
 * 
 * @return {React.ReactElement} The React element for the Google Render Button component.
 */
const GoogleRenderButton = (props : IGoogleRenderButton) : React.ReactElement => {

    return (
        <PillButton
            onClick={props.onClick}
            disableUppercase={true}
            text={props.text ?? 'Log In with Google'}
            textClassName={'fs15'}
            className={props.className ? props.className : 'w250 mt20'}
            icon={
                <img src={`${ASSET_BASE}/assets/images/icons/google_icon.svg`}
                    style={{ width: '50px', height: '50px' }} 
                />}
        />
    );
};

export default GoogleRenderButton;
